import { boundMethod } from 'autobind-decorator';
import ObjectUtils from 'wootils/shared/objectUtils';

class SelectedJobOptions {
  _storeKey = 'selected-job-option';
  _accountId = null;
  _jobId = null;
  constructor(appSession, appSessionStore, productFeedsJobs) {
    'inject';

    this._appSessionStore = appSessionStore;
    this._productFeedsJobs = productFeedsJobs;

    appSession.onSessionEnd(this._cleanUp);

    this._loadInitialState();
  }
  select(accountId, jobInformation) {
    this._appSessionStore.setWithKey(this._storeKey, ObjectUtils.merge(
      jobInformation,
      { accountId },
    ));

    this._accountId = accountId;
    this._jobId = jobInformation.id;
  }
  /**
   * Removes the selected account information.
   */
  unselect() {
    this._accountId = null;
    this._jobId = null;
    this._appSessionStore.deleteKey(this._storeKey);
  }
  validate(accountId, jobId) {
    let result;
    const hasSavedState = this._jobId !== null;
    const savedStateMatchesId = hasSavedState && jobId === this._jobId;

    if (hasSavedState && savedStateMatchesId) {
      result = Promise.resolve();
    } else {
      if (hasSavedState) {
        this._appSessionStore.deleteKey(this._storeKey);
      }

      result = this._loadJobInformation(accountId, jobId)
      .then((jobInformation) => {
        this.select(accountId, jobInformation);
      });
    }

    return result
    .then(() => this._appSessionStore.getFromKey(this._storeKey));
  }
  get jobId() {
    return this._jobId;
  }
  get loading() {
    return this._loading;
  }
  @boundMethod
  _cleanUp() {
    this._appSessionStore.deleteKey(this._storeKey);
  }
  _loadInitialState() {
    const saved = this._appSessionStore.getFromKey(this._storeKey);
    if (saved) {
      this._jobId = saved.id;
      this._accountId = saved.accountId;
    }
  }
  _loadJobInformation(accountId, jobId) {
    this._loading = true;
    return this._productFeedsJobs.getJob(accountId, jobId)
    .then((account) => {
      this._loading = false;
      return account;
    })
    .catch((error) => {
      this._loading = false;
      return Promise.reject(error);
    });
  }
}

export { SelectedJobOptions };
